import { useMutation } from '@tanstack/react-query'

import { postFeedback } from '@/features/yakureki/apis/yakurekiFeedback'

interface PostFeedbackVariables {
  yakurekiId: string
  note: string
}

/**
 * 改善依頼の送信 Mutation。
 *
 * 画面に状態を残さない機能なので cache の invalidate はしない (薬歴詳細は変わらない)。
 * 失敗の見せ方は呼び出し側 (dialog の中に出して文章を失わせない) が決めるため toast も出さない。
 */
export const usePostFeedbackMutation = () =>
  useMutation({
    mutationFn: ({ yakurekiId, note }: PostFeedbackVariables) =>
      postFeedback(yakurekiId, note),
  })
